import { createFileRoute } from "@tanstack/react-router";
import { AvtalerPage } from "@/features/avtaler/AvtalerPage";

export const Route = createFileRoute("/_app/avtaler/")({
  component: Index,
  head: () => ({
    meta: [
      {
        title: "Mine avtaler | Norgespris for Fjernvarme",
      },
    ],
  }),
});

function Index() {
  return (
    <main className="w-full">
      <AvtalerPage />
    </main>
  );
}
